var collapsible_list_component_rtlignore_default = {
  "ltr": "Fyqlk",
  "rtl": "q5ux-",
  "iconContainer": "m2WJ8",
  "icon": "Fdva8",
  "isExpanded": "Nz9wd",
  "listDimensions": "E718z"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
